import { render, staticRenderFns } from "./highLightDetail.vue?vue&type=template&id=a1bb0732&scoped=true"
import script from "./highLightDetail.vue?vue&type=script&lang=js"
export * from "./highLightDetail.vue?vue&type=script&lang=js"
import style0 from "./highLightDetail.vue?vue&type=style&index=0&id=a1bb0732&prod&scoped=true&lang=css"
import style1 from "./highLightDetail.vue?vue&type=style&index=1&id=a1bb0732&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1bb0732",
  null
  
)

export default component.exports